import { Hero } from "../components/Hero";
import { Nav } from "../components/Nav";
import { Services } from "../components/Services";
import { SpecialtyService } from "../components/SpecialtyService";
import { RecentProjects } from "../components/RecentProjects";
import { Metrics } from "../components/Metrics";
import { Footer } from "../components/Footer";
import { Contact } from "../components/Contact";
import { Seo } from "../components/Seo";

declare global {
	interface Window {
		gtag?: (...args: any[]) => void;
	}
}

export default function Home() {
	return (
		<>
			<Seo title="Gova Engineering | Civil Engineering in Austin, TX" description="Civil engineering, site development, permitting, water and wastewater design, and project management across Central Texas." path="/" />
			<div className="min-h-screen bg-background flex flex-col items-center justify-center">
				<Nav />
				<Hero />
				<Services />
				<SpecialtyService />
				<RecentProjects />
				<Metrics />
				<Contact />
				<Footer />
			</div>
		</>
	);
}
